export function burgerInit() {
    const $b = $('.burger-head');

    $b.on('click', () => {
       $('body').toggleClass('show-site-menu');
    });
}
